module.exports = __webpack_public_path__ + "static/media/hebe.8265592b.png";